import { Building2, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { DataTable } from "../components/DataTable";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { usePropertyLeases } from "../data/assets-platform-data";

export function PropertyLeasesPage() {
  const query = usePropertyLeases();
  if (query.isLoading) return <Skeleton className="dashboard-skeleton" />;
  if (query.error) {
    return (
      <EmptyState title="Não foi possível carregar as locações" description={query.error.message} />
    );
  }

  return (
    <Card
      title="Locação de imóveis"
      description="Contratos, reajustes, garantias e cobranças mensais."
      action={
        <Link to="/operacoes/nova?tipo=property-lease">
          <Button>
            <Plus size={16} /> Nova locação
          </Button>
        </Link>
      }
    >
      <DataTable
        rows={query.data ?? []}
        getKey={(row) => row.id}
        columns={[
          {
            key: "number",
            header: "Contrato",
            render: (row) => (
              <span className="strong-link">
                <Building2 size={15} /> {row.number}
              </span>
            ),
          },
          { key: "tenant", header: "Locatário", render: (row) => row.tenant },
          { key: "property", header: "Imóvel", render: (row) => row.property },
          { key: "rent", header: "Aluguel", render: (row) => row.monthlyRent },
          { key: "due", header: "Vencimento", render: (row) => `Dia ${row.dueDay}` },
          {
            key: "period",
            header: "Vigência",
            render: (row) => `${row.startsAt} a ${row.endsAt}`,
          },
          {
            key: "status",
            header: "Status",
            render: (row) => (
              <Badge tone={row.status === "ACTIVE" ? "success" : "danger"}>{row.status}</Badge>
            ),
          },
        ]}
      />
    </Card>
  );
}
